import React from "react";
import { useLocation } from "react-router-dom";

import "./style.css";
import DateFilter from "../../Components/Date Filter/DateFilter";
import { Switch } from "antd";
import SwitchToggle from "../ToggleSwitch";

const UserLayout = ({ children, name }) => {
  const location = useLocation();
  return (
    <div className="user-layout">
      {location.pathname === "/settings" ? (
        <></>
      ) : (
        <div className="wrapper-top">
          <div className="left">
            <span className="title">Welcome to {name}! 👋</span>
            <span className="sub-title">
              Everything you need to know, at a glance.
            </span>
          </div>
          <div className="right">
            <DateFilter />
          </div>
          {location.pathname.endsWith("/fuel") && (
            <div className="right">
              <div className="switch-toggle">
                <span className="switch-label">Sensored Vehicles: </span>
                <SwitchToggle />
              </div>
            </div>
          )}
        </div>
      )}
      {children}
    </div>
  );
};

export default UserLayout;
